<button
  (click)="emitClick()"
  type="button"
  class="w-64 nowrap justify-start flex items-center gap-4"
>
  <div
    class="w-20"
    [ngClass]="{ 'rotate-180': isOpen }"
  >
    <app-triangle></app-triangle>
  </div>
  <span *ngIf="isOpen">Hide</span>
  <span *ngIf="!isOpen">Show</span>
</button>
